'use strict'

import game from './game'
import hilolocal from './hilolocal'

export default { game, hilolocal }



// WEBPACK FOOTER //
// ./resources/assets/js/hilolocal/api/index.js